<ridango-page-content-wrapper>
    <div class="portal-file-list">
        <ul
            class="list-items -mx-1 mt-1 columns-2 text-sm lg:columns-1"
            innerHtml="{{ 'CORPORATE_PORTAL_MANUAL' | translate }}"
            ridangoTranslatedLink></ul>
    </div>
</ridango-page-content-wrapper>
